var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroWindowsRunningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.582,
    height: 138.894,
    viewBox: "0 0 148.582 138.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(-390.151 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(386.75 207.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M151.983,121.2V25.613c0-12.489-4.895-18.294-15.651-18.294H19.476C8.72,7.319,3.4,13.124,3.4,25.613V121.2H71.412V134.55H45.444v11.663h64.92V134.55H84.4V121.2Zm-139-95.59c0-4.163,2.907-7.538,6.492-7.538H136.331c3.585,0,6.492,3.375,6.492,7.538v82.913H12.984Z",
    transform: "translate(0 0)",
    fill: "#8cbe82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(283.073 -72.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft",
    transform: "translate(144 306.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M272,35.033h35.033V2.336A2.336,2.336,0,0,0,304.7,0H272Z",
    transform: "translate(-232.296)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M35.033,35.033V0H2.336A2.336,2.336,0,0,0,0,2.336v32.7Z",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M35.033,272H0v32.7a2.336,2.336,0,0,0,2.336,2.336h32.7Z",
    transform: "translate(0 -232.296)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M272,272v35.033h32.7a2.336,2.336,0,0,0,2.336-2.336V272Z",
    transform: "translate(-232.296 -232.296)",
    fill: "#ffc107"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroWindowsRunningIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroWindowsRunningIcon.13be8f00816a196173a7e2607b4fabba.svg";
export { ForwardRef as ReactComponent };